<template>
  <div>
    <label class="item-name">{{initComponent.name}}</label>
    <div class="component-content">
      <el-switch :class="{onlyread:component.properties.readonly}" v-model="value" disabled/>
    </div>
  </div>
</template>

<script>
import { componentMixin } from '../mixins'

export default {
  name: 'rc-switch',
  props: ['initComponent'],
  mixins: [ componentMixin ],
  data () {
    return {
      value: false,
      component: this.initComponent
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/components/form/components/switch/rc-switch.vue